"use strict";

var _regeneratorRuntime = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default(_ref) {
  var signalService = _ref.signalService;
  return {
    name: 'kill',
    synopsis: 'kill [JOB ID]',
    description: 'Send a signal to a job',
    options: {
      1: {
        alias: 'SIGINT',
        type: 'boolean',
        description: 'Request a job to interrupt'
      },
      2: {
        alias: 'SIGSTP',
        type: 'boolean',
        description: 'Request a job to stop'
      },
      3: {
        alias: 'SIGRES',
        type: 'boolean',
        description: 'Request a job to resume'
      }
    },
    execute: function execute(_ref2, _ref3) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref4, jobId, SIGSTP, SIGRES, signal;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref4 = _slicedToArray(_ref2, 1), jobId = _ref4[0];
                SIGSTP = _ref3.SIGSTP, SIGRES = _ref3.SIGRES;
                signal = SIGRES ? 3 : SIGSTP ? 2 : 1;
                signalService.send(jobId, signal);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
};

exports.default = _default;